import { createSlice }         from '@reduxjs/toolkit';
import * as userTicketReducers from 'Redux/Reducers/UserTicket';
import { UserTicket }          from 'Domain/Models';

export interface IUserTicketState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  entries: Record<string, UserTicket>,
  lastUpdateId: string | null,
  maxCount: number,
}

export const userTicketSlice = createSlice({
  name: 'userTicket',
  initialState: {
    openRequests: [],
    failedRequests: [],
    entries: {},
    maxCount: 0,
    lastUpdateId: null,
    updatedAt: 0,
  },
  reducers: userTicketReducers,
});
